import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const prodConfig = {
  apiKey: "AIzaSyAkTHIHUeIbYxRS7YU9M6tNfXaaXxRKCsA",
  authDomain: "sud-firestore.firebaseapp.com",
  databaseURL: "https://sud-firestore.firebaseio.com",
  projectId: "sud-firestore",
  cors: {
    origin: false
  }
};

const devConfig = {
  apiKey: "AIzaSyCEqmovVzKc0hlZQsx2k2oIhFcXjOppjTo",
  authDomain: "squeaky-dev.firebaseapp.com",
  databaseURL: "https://squeaky-dev.firebaseio.com",
  projectId: "squeaky-dev",
  cors: {
    origin: false
  }
};

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const firestore = firebase.firestore();
// Need this to avoid Firestore Timestamp deprecation warning
// const settings = { timestampsInSnapshots: true };
// firestore.settings(settings);

const cloudFunctions = firebase.functions();

const auth = firebase.auth();

export { firestore, cloudFunctions, auth };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js